import { ActionButton } from "../../ui/action-button";

type LoginPageProps = {
  busy: boolean;
  error?: string;
  onLogin: () => Promise<void>;
};

function GoogleIcon() {
  return (
    <svg aria-hidden="true" className="auth-google-icon" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.6 12.2c0-.8-.1-1.6-.2-2.3H12v4.4h5.9a5 5 0 0 1-2.2 3.3v2.7h3.6a10.8 10.8 0 0 0 3.3-8.1z" />
      <path fill="#34A853" d="M12 23c3 0 5.5-1 7.3-2.7l-3.6-2.7c-1 .7-2.2 1-3.7 1a6.5 6.5 0 0 1-6.1-4.5H2.2v2.8A11 11 0 0 0 12 23z" />
      <path fill="#FBBC05" d="M5.9 14.1a6.6 6.6 0 0 1 0-4.2V7.1H2.2a11 11 0 0 0 0 9.8z" />
      <path fill="#EA4335" d="M12 5.4c1.6 0 3.1.6 4.2 1.7l3.2-3.2A10.8 10.8 0 0 0 12 1 11 11 0 0 0 2.2 7.1l3.7 2.8A6.5 6.5 0 0 1 12 5.4z" />
    </svg>
  );
}

export function LoginPage({ busy, error, onLogin }: LoginPageProps) {
  return (
    <main className="auth-page">
      <h1 className="sr-only">Sign in</h1>
      <section className="auth-action" aria-label="Authentication">
        <ActionButton className="auth-provider-button" tone="primary" isDisabled={busy} onPress={onLogin}>
          <GoogleIcon />
          <span>{busy ? "Signing in" : "Continue with Google"}</span>
        </ActionButton>
        {error ? <p className="auth-error" role="alert">{error}</p> : null}
      </section>
    </main>
  );
}
